import CartePage from "./CartePage";
import { cartePetitDejeuner } from "../data/menus";

const HERO = "/petit-dejeuner.webp";

// Photos UNIQUEMENT de plats / boissons de la carte
const GALLERY = [
  // Cappuccino / latte art
  "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1600&q=80",
  // Jus pressé / smoothie matin
  "https://images.unsplash.com/photo-1610970881699-44a5587cabec?auto=format&fit=crop&w=1600&q=80",
];

export default function CartePetitDejeunerPage() {
  return (
    <CartePage
      data={cartePetitDejeuner}
      heroImg={HERO}
      galleryImgs={GALLERY}
      subtitleKey="petitDejeuner"
      titleKey="petitDejeuner"
      testid="page-carte-petit-dejeuner"
    />
  );
}
